//RepoWeb Change 16.4
export const DATE_FORMAT = 'MM/dd/yyyy';
export const CAN_POSTAL_PATTERN = /^[a-z]\d[a-z][ -]?\d[a-z]\d$/i;
export const USA_ZIP_PATTERN = /^\d{5}(-\d{4})?$/;
export const ACTION_ACCEPT = 'Contractor Accepted Assignment';
export const ACTION_CANCEL = 'Contractor Acknowledge Cancel Assignment';
export const ACTION_DECLINE = 'Contractor Acknowledge Decline Assignment';
export const ACTION_HOLD = 'Contractor Acknowledge Hold Assignment';
export const ACTION_GROUNDING = 'Vehicle grounded - VCR created';
export const ACTION_TAKEN = 'Action Taken:';
export const rsACCEPT = 'ACCEPT';
export const rsGROUNDED = 'GROUNDED';
export const rsDECLINE = 'DECLINE';
export const rsHOLD_CONFIRM = 'HOLD_CONFIRMATION';
export const rsCANCEL_CONFIRM = 'CANCEL_CONFIRMATION';
export const rs_CONTRACTOR_UDATE  = 'Workflow contractor update';


  export const rs_COMMENT_TXT  = ' | Comment:';
export const API_ENDPOINT_IS_CONTRACTOR_AVAILABLE = 'addContractorProfile/isContractorAvailable';

export const API_ENDPOINT_REPO_SECURITY_REPO_USER_ID = 'repoSecurity/isRepoUser/id?userId=';
export const API_ENDPOINT_REPO_USER_DETAIL = 'repoSecurity/isRepoUser/detail?userId=';
export const API_ENDPOINT_REPO_SECURITY_SITE_CODE_ID = 'repoSecurity/isRepoUser/sitecode?gsdbCd=';

export const API_ENDPOINT_GET_CONTRACTOR_ID_DETAILS = 'modifyContractorProfile/getContractorIdDetails/';
